q<template>
<div class="payment-form">
    <section>
        <input v-model="paymentType" value="card" type="radio" id="type-card" />
        <label for="type-card">Credit Card</label>
    </section>

    <div v-if="paymentType=='card'">

        <div class="form-split">
            <section>
                <label>First Name</label>
                <input v-model="paymentInfo.firstName" @blur="checkFirstName" ref="firstName" />
                <span ref="firstNameError"></span>
            </section>
            <section>
                <label>Last Name</label>
                <input v-model="paymentInfo.lastName" @blur="checkLastName" ref="lastName" />
                <span ref="lastNameError"></span>
            </section>
        </div>

        <section>
            <label>Card Number</label>
            <input v-model="paymentInfo.cardNumber" @blur="checkCardNumber" v-mask="'#### #### #### ####'" ref="cardNumber" />
            <span ref="cardNumberError"></span>
        </section>

        <div class="form-split">
            <section>
                <label>Expiration</label>
                <input v-model="paymentInfo.expiration" @blur="checkExp" v-mask="'##/##'" placeholder="MM/YY" ref="exp" />
                <span ref="expError"></span>
            </section>
            <section>
                <label>CVV</label>
                <input v-model="paymentInfo.cardCVV" @blur="checkCVV" v-mask="'####'" ref="cvv" />
                <span ref="cvvError"></span>
            </section>
        </div>

        <div class="form-split-address">
            <section>
                <label>Address</label>
                <input v-model="paymentInfo.address" @blur="checkAddress" ref="address" />
                <span ref="addressError"></span>
            </section>
            <section>
                <label>Zip Code</label>
                <input v-model="paymentInfo.zipCode" @blur="checkZip" ref="zipCode" v-mask="'#####'" maxlength="5" />
                <span ref="zipCodeError"></span>
            </section>
        </div>

    </div>

    <section>
        <input v-model="paymentType" value="paypal" type="radio" id="type-paypal" />
        <label for="type-paypal">PayPal</label>
    </section>

    <button @click="onSubmit" class="btn btn-block btn-primary mt-3">
        Submit
    </button>
</div>
</template>

<script>
import Validation from "@/../submodules/vue-base/mixins/Validation";
import CreditCardType from "@/../submodules/vue-base/mixins/CreditCardType";

export default {

    name: "PaymentForm",

    mixins: [
        Validation,
        CreditCardType
    ],

    data() {
        return {
            paymentInfo: {
                creditCardType: "",
                firstName: "",
                lastName: "",
                cardNumber: "",
                cardCVV: "",
                expiration: "",
                expMonth: "",
                expYear: "",

                address: "",
                zipCode: "",
            },
            paymentType: "card"
        }
    },

    methods: {
        onSubmit() {

			if(this.paymentType=="paypal"){
				this.$emit("paypal");
				return;
			}

            if (!(this.checkFirstName() &
                    this.checkLastName() &

                    this.checkCardNumber() &
                    this.checkCVV() &
                    this.checkExp() &

                    this.checkAddress() &
                    this.checkZip()
                )) {
                return;
            }

            this.paymentInfo.cardNumber = this.paymentInfo.cardNumber.replace(/\s/g, '');
            this.paymentInfo.creditCardType = this.getCardType(this.paymentInfo.cardNumber)
            var expirationSplit = this.paymentInfo.expiration.split("/");
            this.paymentInfo.expMonth = expirationSplit[0];
            this.paymentInfo.expYear = expirationSplit[1];

            this.$emit("submit");
        },

        checkFirstName() {
            if (!(this.validName(this.paymentInfo.firstName))) {
                this.$refs.firstName.classList.add("is-invalid");
                this.$refs.firstNameError.innerHTML = "Invalid first name";
                return false;
            }
            this.$refs.firstName.classList.remove("is-invalid");
            return true;
        },

        checkLastName() {
            if (!(this.validName(this.paymentInfo.lastName))) {
                this.$refs.lastName.classList.add("is-invalid");
                this.$refs.lastNameError.innerHTML = "Invalid last name";
                return false;
            }
            this.$refs.lastName.classList.remove("is-invalid");
            return true;
        },

        checkCVV() {
            if (!this.validCVV(this.paymentInfo.cardCVV)) {
                this.$refs.cvv.classList.add("is-invalid");
                this.$refs.cvvError.innerHTML = "Invalid CVV";
                return false;
            }
            this.$refs.cvv.classList.remove("is-invalid");
            return true;
        },

        checkCardNumber() {
            if (!this.validCard(this.paymentInfo.cardNumber.replace(/\s/g, ''))) {
                this.$refs.cardNumber.classList.add("is-invalid");
                this.$refs.cardNumberError.innerHTML = "Invalid Card";
                return false;
            }
            this.$refs.cardNumber.classList.remove("is-invalid");
            return true;
        },

        checkZip() {
            if (!this.validZip(this.paymentInfo.zipCode)) {
                this.$refs.zipCode.classList.add("is-invalid");
                this.$refs.zipCodeError.innerHTML = "Invalid Zip Code";
                return false;
            }
            this.$refs.zipCode.classList.remove("is-invalid");
            return true;
        },

        checkAddress() {
            if (!this.validAddress(this.paymentInfo.address)) {
                this.$refs.address.classList.add("is-invalid");
                this.$refs.addressError.innerHTML = "Invalid Address";
                return false;
            }
            this.$refs.address.classList.remove("is-invalid");
            return true;
        },

        checkExp() {
            var expirationSplit = this.paymentInfo.expiration.split("/");
            this.paymentInfo.expMonth = expirationSplit[0];
            this.paymentInfo.expYear = expirationSplit[1];

            if (!this.validCardExp(this.paymentInfo.expMonth, this.paymentInfo.expYear)) {
                this.$refs.exp.classList.add("is-invalid");
                this.$refs.expError.innerHTML = "Credit Card expiration is invalid";
                return false;
            }
            this.$refs.exp.classList.remove("is-invalid");
            return true;
        },
    },
}
</script>

<style lang="less" scoped>
@import (reference) "@/assets/less/style.less";

button {
    display: block;
    width: 100%;

}

.payment-form {

    input[type="radio"] {
        float: left;
    }

    section {
        margin-bottom: 1.5em;
        position: relative;

        span {
            font-size: .9em;
            position: absolute;
            left: 0;
            bottom: -1.3em;
        }

    }

}

@media @breakpoint-md-up {

    .form-split {
        display: flex;

        section:first-child {
            .make-col(6);
            padding-right: 1rem;
        }

        section:last-child {
            .make-col(6);
        }
    }

    .form-split-address {
        display: flex;

        section:first-child {
            .make-col(9);
            padding-right: 1rem;
        }

        section:last-child {
            .make-col(3);
        }
    }

}
</style>
